export default "__VITE_ASSET__BdkgUSXY__"